import Images from "../../ALL_Images/Images.js";
export const Travel = [
  {
    src: Images.new_5,
    cols: 2,
  },
  {
    src: Images.new_2,
  },
  {
    src: Images.new_3,
  },
  {
    src: Images.new_4,
    cols: 2,
  },
  {
    src: Images.new_1,
    cols: 2,
    // rows:2
  },
  {
    src: Images.new_6,
    rows: 1,
  },
  {
    src: Images.new_7,
  },
  {
    src: Images.new_8,
    cols: 2,
  },
  {
    src: Images.new_9,
    cols: 2,
  },
  {
    src: Images.new_10,
  },
];

export const babyshoot = [
  {
    src: Images.babyshoot_1,
    cols: 2,
  },
  {
    src: Images.babyshoot_2,
  },
  {
    src: Images.babyshoot_3,
  },
  {
    src: Images.babyshoot_4,
    cols: 2,
  },
  {
    src: Images.babyshoot_5,
    cols: 2,
    rows: 2,
  },
  {
    src: Images.babyshoot_6,
    rows: 2,
  },
  {
    src: Images.babyshoot_7,
  },
  {
    src: Images.babyshoot_8,
    cols: 2,
  },
  {
    src: Images.babyshoot_9,
    cols: 2,
  },
  {
    src: Images.babyshoot_10,
  },
  {
    src: Images.babyshoot_11,
    rows: 2,
    cols: 2,
  },
  {
    src: Images.babyshoot_12,
    rows: 2,
  },
  {
    src: Images.babyshoot_13,
    rows: 2,
  },
  {
    src: Images.babyshoot_14,
    cols: 2,
    rows: 2,
  },
  {
    src: Images.babyshoot_15,
    cols: 2,
    rows: 2,
  },
  {
    src: Images.babyshoot_16,
    rows: 2,
  },
  {
    src: Images.babyshoot_17,
  },
  {
    src: Images.babyshoot_18,
    cols: 2,
  },
  {
    src: Images.babyshoot_19,
    cols: 2,
    // rows: 2
  },
  {
    src: Images.babyshoot_20,
    // rows: 2
  },
];

export const personal = [
  {
    src: Images.personal_1,
    rows: 2,
    cols: 1,
  },
  {
    src: Images.personal_2,
    rows: 2,
    cols: 1,
  },
  {
    src: Images.personal_3,
    cols: 1,
    rows: 2,
  },
  {
    src: Images.personal_4,
    cols: 2,
    rows: 2,
  },
  {
    src: Images.personal_5,
    cols: 1,
    rows: 2,
  },
  {
    src: Images.personal_6,
    cols: 1,
    rows: 2,
  },
  {
    src: Images.personal_7,
    rows: 2,
  },
  {
    src: Images.personal_8,
    rows: 2,
    cols: 1,
  },
  {
    src: Images.personal_9,
    cols: 1,
    rows: 2,
  },
  {
    src: Images.personal_10,
    rows: 2,
    cols: 2,
  },
  {
    src: Images.personal_11,
    cols: 2,
    rows: 2,
  },
  {
    src: Images.personal_12,
    rows: 2,
  },
  {
    src: Images.personal_13,
    rows: 2,
  },
  {
    src: Images.personal_14,
    rows: 2,
    cols: 1,
  },
  {
    src: Images.personal_16,
    cols: 1,
    rows: 2,
  },
  {
    src: Images.personal_15,
    cols: 1,
  },
  {
    src: Images.personal_17,
  },
  {
    src: Images.personal_18,
    cols: 1,
  },
  {
    src: Images.personal_19,
    cols: 2,
    rows: 2,
  },
  {
    src: Images.personal_20,
    rows: 2,
  },
  {
    src: Images.personal_21,
    cols: 1,
    rows: 2,
  },
  {
    src: Images.personal_22,
    cols: 2,
    rows: 2,
  },
  {
    src: Images.personal_23,
    rows: 2,
  },
  {
    src: Images.personal_24,
    rows: 2,
    cols: 2,
  },
  {
    src: Images.personal_25,
    rows: 2,
    cols: 2,
  },
  {
    src: Images.personal_26,
    rows: 2,
  },
  {
    src: Images.personal_27,
    rows: 1,
    cols: 1,
  },
  {
    src: Images.personal_28,
    rows: 1,
    cols: 1,
  },
  {
    src: Images.personal_29,
    rows: 1,
    cols: 1,
  },
  {
    src: Images.personal_30,
    cols: 1,
    rows: 1,
  },
  {
    src: Images.personal_31,
    rows: 1,
    cols: 1,
  },
  {
    src: Images.personal_32,
    rows: 1,
    cols: 1,
  },
];

export const prewedding = [
  {
    src: Images.prewedding_1,
    rows: 2,
    cols: 1,
  },
  {
    src: Images.prewedding_2,
    rows: 2,
    cols: 1,
  },
  {
    src: Images.prewedding_3,
    rows: 2,
    cols: 1,
  },
  {
    src: Images.prewedding_4,
    rows: 2,
    cols: 1,
  },
  {
    src: Images.prewedding_5,
    rows: 2,
    cols: 1,
  },
  {
    src: Images.prewedding_6,
    rows: 2,
    cols: 1,
  },
  {
    src: Images.prewedding_7,
    rows: 2,
    cols: 1.5,
  },
  {
    src: Images.prewedding_8,
    rows: 2,
    cols: 1.5,
  },
  {
    src: Images.prewedding_9,
    rows: 2,
    cols: 2,
  },
  {
    src: Images.prewedding_10,
    rows: 2,
  },
  {
    src: Images.prewedding_11,
    rows: 2,
    cols: 2,
  },
  {
    src: Images.prewedding_12,
    rows: 2,
  },
  {
    src: Images.prewedding_13,
    rows: 2,
    cols: 1.5,
  },
  {
    src: Images.prewedding_14,
    rows: 2,
    cols: 1.5,
  },
  {
    src: Images.prewedding_15,
    rows: 2,
    cols: 1,
  },
  {
    src: Images.prewedding_16,
    rows: 2,
    cols: 1,
  },
  {
    src: Images.prewedding_17,
    rows: 2,
  },
  {
    src: Images.prewedding_18,
    rows: 2,
    cols: 1.5,
  },
  {
    src: Images.prewedding_19,
    rows: 2,
    cols: 1.5,
  },
  {
    src: Images.prewedding_20,
    rows: 2,
  },
  {
    src: Images.prewedding_21,
    rows: 2,
    cols: 2,
  },
  {
    src: Images.prewedding_22,
    rows: 2,
  },
  {
    src: Images.prewedding_23,
    rows: 2,
  },
  {
    src: Images.prewedding_24,
    rows: 2,
    cols: 1,
  },
  {
    src: Images.prewedding_25,
    rows: 2,
    cols: 2,
  },
  {
    src: Images.prewedding_26,
    rows: 2,
  },
  {
    src: Images.prewedding_27,
    rows: 2,
  },
  {
    src: Images.prewedding_28,
    rows: 2,
    cols: 2,
  },
  {
    src: Images.prewedding_29,
    rows: 2,
    cols: 2,
  },
  {
    src: Images.prewedding_30,
    rows: 2,
  },
];

export const Business = [
  {
    src: Images.business_1,
    rows: 2,
    cols: 1.5,
  },
  {
    src: Images.business_2,
    rows: 2,
    cols: 1.5,
  },
  {
    src: Images.business_3,
    rows: 2,
  },
  {
    src: Images.business_4,
    rows: 2,
    cols: 2,
  },
];

export const Wedding = [
  {
    src: Images.wedding_1,
    rows: 1,
    cols: 1.5,
  },
  {
    src: Images.wedding_2,
    rows: 1,
    cols: 1.5,
  },
  {
    src: Images.wedding_3,
    rows: 2,
  },
  {
    src: Images.wedding_4,
    rows: 2,
    cols: 2,
  },
  {
    src: Images.wedding_5,
    rows: 2,
    cols: 2,
  },
  {
    src: Images.wedding_6,
    rows: 2,
  },
  {
    src: Images.wedding_7,
    rows: 2,
    cols: 1.5,
  },
  {
    src: Images.wedding_8,
    rows: 2,
    cols: 1.5,
  },
];

export const Maternity = [
  {
    src: Images.maternity_1,
    rows: 2,
    cols: 1,
  },
  {
    src: Images.maternity_2,
    rows: 2,
    cols: 1,
  },
  {
    src: Images.maternity_3,
    rows: 2,
    cols: 1,
  },
  {
    src: Images.maternity_4,
    rows: 2,
    cols: 1.5,
  },
  {
    src: Images.maternity_5,
    rows: 2,
    cols: 1.5,
  },
];

export const Family = [
  {
    src: Images.family_1,
    cols: 1,
    rows: 2,
  },
  {
    src: Images.family_2,
    rows: 2,
    // cols: 2
  },
  {
    src: Images.family_3,
    rows: 2,
  },
  {
    src: Images.family_4,
    rows: 2,
    cols: 1,
  },
  {
    src: Images.family_5,
    rows: 2,
    cols: 2,
  },
  {
    src: Images.family_6,
    rows: 2,
    cols: 1.5,
  },
  {
    src: Images.family_7,
    rows: 2,
    cols: 1.5,
  },
  {
    src: Images.family_8,
    rows: 2,
    cols: 1,
  },
  {
    src: Images.family_9,
    rows: 2,
    cols: 2,
  },
];

export const Other = [
  {
    src: Images.other_1,
    cols: 1,
    rows: 2,
  },
  {
    src: Images.other_2,
    cols: 2,
    rows: 2,
  },
  {
    src: Images.other_3,
    cols: 1,
    // rows:2
  },
  {
    src: Images.other_4,
    cols: 1,
    // rows:2
  },
  {
    src: Images.other_5,
    cols: 1,
    // rows: 2
  },
  {
    src: Images.other_6,
    // cols: 2,
    // rows: 2
  },
  {
    src: Images.other_7,
    cols: 1,
  },
  {
    src: Images.other_8,
    cols: 1,
  },
];
